import instanceService from './instance'

import { CASH_BOX_SERVER_URL, SEARCH_SERVER_URL } from '../helpers/constants'
import { couponType } from '../helpers/data-constants'

let instance = instanceService.instance(CASH_BOX_SERVER_URL)
let carInstance = instanceService.instance(SEARCH_SERVER_URL)

export const cashBoxService = {
  getCashBox,
  getCashBoxes,
  getCashBoxCoupons,
  createCashBox,
  updateCashBox,
  createBaseCoupon,
  updateBaseCoupon,
  updateBaseCouponList,
  createCoupon,
  createCouponList,
  updateCoupon,
  updateCoupons,
  activateCoupons,
  deleteCoupons,
  getPurityGroups,
  getCurrentPurities,
  updatePurities,
  getWords,
  createWord,
  updateWord,
  deleteWord,
  typeaheadCashBox,
  getCountries,
  getAvailableCashBoxes,
  calculate,
  createContract,
  getJewels,
  createJewel,
  updateJewel,
  getReasons,
  createReason,
  updateReason,
  getShortCashBoxList,
  createCar,
  updateCar,
  deleteCar,
  getCars,
  createBranch,
  typeaheadBranches,
  putBranch,
  getBranches,
  deleteBranch,
  getAllBranches,
  getDepartmentsTab
}

function getDepartmentsTab(data) {
  const options = {
    method: 'POST',
    data: data,
    url: '/cashboxes/search'
  }
  return instance(options)
}

function createBranch(data) {
  const options = {
    method: 'POST',
    data: data,
    url: '/branch'
  }
  return instance(options)
}

function putBranch(data, id) {
  const options = {
    method: 'PUT',
    data: data,
    url: `/branch/${id}`
  }
  return instance(options)
}

function typeaheadBranches(name) {
  const options = {
    method: 'GET',
    url: '/branch/typeahead?name=' + name
  }
  return instance(options)
}

function getBranches(data) {
  const options = {
    method: 'POST',
    data: data,
    url: '/branches'
  }
  return instance(options)
}

function deleteBranch(id) {
  const options = {
    method: 'DELETE',
    url: `/branch/${id}`
  }
  return instance(options)
}

function getCashBoxes(data) {
  const options = {
    method: 'POST',
    data: data,
    url: '/cashboxes'
  }
  return instance(options)
}

function getAvailableCashBoxes() {
  const options = {
    method: 'GET',
    url: '/cashboxes/available'
  }
  return instance(options)
}

function typeaheadCashBox(name, restrictionRole = false, isMain = false) {
  const options = {
    method: 'GET',
    url: `/cashboxes/typeahead?name=${name}&restrictionRole=${restrictionRole}&isMain=${isMain}`
  }
  return instance(options)
}

function getCashBox(id, active = true, type = couponType.SHORT_TERM) {
  return instance.get(`${id}?active=${active}`, {
    params: {
      couponTypes: type
    }
  })
}

function getCashBoxCoupons(id, { date, couponTypes }) {
  if (!date) {
    return instance.get(`${id}/coupons`, {
      params: { couponTypes }
    })
  } else {
    return instance.get(`${id}/coupons?date=${date}`)
  }

}

function createCashBox(data) {
  const options = {
    method: 'POST',
    data: data,
    url: '/'
  }
  return instance(options)
}

function updateCashBox(id, data) {
  const options = {
    method: 'PATCH',
    data: data,
    url: `/${id}`
  }
  return instance(options)
}

function createBaseCoupon(cashBoxId, data) {
  const options = {
    method: 'POST',
    data: data,
    url: `/${cashBoxId}/base/coupon`
  }
  return instance(options)
}

function createCoupon(cashBoxId, data) {
  const options = {
    method: 'POST',
    data: data,
    url: `/${cashBoxId}/coupon`
  }
  return instance(options)
}

function createCouponList(cashBoxIds, data) {
  const options = {
    method: 'POST',
    data: data,
    url: `/${cashBoxIds}/coupon/list`
  }
  return instance(options)
}

function updateBaseCoupon(cashBoxId, data) {
  const options = {
    method: 'PUT',
    data: data,
    url: `/${cashBoxId}/base/coupon`
  }
  return instance(options)
}

function updateCoupon(cashBoxId, couponId, data) {
  const options = {
    method: 'PUT',
    data: data,
    url: `/${cashBoxId}/coupon/${couponId}`
  }
  return instance(options)
}

function updateCoupons(cashBoxId, couponIds, data) {
  const options = {
    method: 'PUT',
    data: data,
    url: `/${cashBoxId}/coupons/${couponIds}`
  }
  return instance(options)
}


function activateCoupons(couponIds, status = true) {
  const options = {
    method: 'PUT',
    url: `/coupons/${couponIds}?active=${status}`
  }
  return instance(options)
}

function deleteCoupons(couponIds) {
  const options = {
    method: 'DELETE',
    url: `/coupons/${couponIds}`
  }
  return instance(options)
}

function updateBaseCouponList(cashBoxIds, data) {
  const options = {
    method: 'PUT',
    data: data,
    url: `/${cashBoxIds}/base/coupon/list`
  }
  return instance(options)
}

function getPurityGroups(date) {
  if (!date) {
    return instance.get(`/purities`)
  } else {
    return instance.get(`/purities?date=${date}`)
  }
}

function getCurrentPurities() {
  return instance.get('/purities/current')
}

function updatePurities(data) {
  const options = {
    method: 'PUT',
    data: data,
    url: `/purities`
  }
  return instance(options)
}

function getWords(type, name) {
  const options = {
    method: 'GET',
    url: `/words/${type}?name=${name}`
  }
  return instance(options)
}

function getJewels(name) {
  const options = {
    method: 'GET',
    url: `/jewel?name=${name}`
  }
  return instance(options)
}


function getReasons(name, type) {
  const options = {
    method: 'GET',
    url: `/reasons?name=${name}&type=${type}`
  }
  return instance(options)
}

function createWord(type, name) {
  const options = {
    method: 'POST',
    data: {
      name: name
    },
    url: `/words/${type}`
  }
  return instance(options)
}

function createJewel(name, synonym, part) {
  const options = {
    method: 'POST',
    data: {
      name: name,
      synonym: synonym,
      part: part,
    },
    url: `/jewel`
  }
  return instance(options)
}

function createReason (formData) {
  const options = {
    method: 'POST',
    data: formData,
    url: `/reasons`
  }
  return instance(options)
}

function updateWord(id, type, name) {
  const options = {
    method: 'PUT',
    data: {
      name: name
    },
    url: `/words/${type}/${id}`
  }
  return instance(options)
}

function updateJewel(id, name, synonym, part) {
  const options = {
    method: 'PUT',
    data: {
      name: name,
      synonym: synonym,
      part: part,
    },
    url: `/jewel/${id}`
  }
  return instance(options)
}

function updateCar (id, brand, model) {
  const options = {
    method: 'PUT',
    data: {
      brand: brand,
      model: model
    },
    url: `/auto/${id}`
  }
  return instance(options)
}

function deleteCar (id) {
  const options = {
    method: 'DELETE',
    url: `/auto/${id}`
  }
  return instance(options)
}

function createCar (brand, model) {
  const options = {
    method: 'POST',
    data: {
      brand: brand,
      model: model
    },
    url: `/auto`
  }
  return instance(options)
}

function getCars (name) {
  const options = {
    method: 'POST',
    data: {
      size: 1000,
      from: 0,
      order: "desc",
      sort: "brand.keyword",
      term: name
    },
    url: `/auto/search`,
  }
  return carInstance(options)
}

function updateReason (id, formData) {
  const options = {
    method: 'PUT',
    data: formData,
    url: `/reasons/${id}`
  }
  return instance(options)
}
function getAllBranches(data) {
  const options = {
    method: 'POST',
    data: data,
    url: '/branch/info'
  }
  return instance(options)
}

function deleteWord(id, type) {
  const options = {
    method: 'DELETE',
    url: `/words/${type}/${id}`
  }
  return instance(options)
}

function getCountries(data) {
  const options = {
    method: 'GET',
    url: `/words/country?searchBy=sw&name=${data}`
  }
  return instance(options)
}

function calculate(data) {
  const options = {
    method: 'POST',
    url: '/calculation',
    data: data,
  }
  return instance(options)
}

function createContract(data) {
  const options = {
    method: 'POST',
    url: '/contract',
    data: data,
  }
  return instance(options)
}

function getShortCashBoxList(ids) {
  const options = {
    method: 'GET',
    url: `/cashboxes/short/${ids}`
  }
  return instance(options)
}
